import CalendarIcon from "@untitled-ui/icons-react/build/esm/Calendar";
import ChevronDown from "@untitled-ui/icons-react/build/esm/ChevronDown";
import { Col, DatePicker, Form, Input, Row, Select } from "antd";
import dayjs from "dayjs";
import { BOM } from "../../../services/definedMethod";
import { labelConfig, staticConfig } from "../serviceProvider.config";

const General = (props) => {
  const {
    form,
    initialValues,
    userData,
    isActive,
    legalFormData,
    officeData,
    legalOption,
    genderData,
    disabledAfterCurrentDate,
    disableDaysBeforeToday,
    clientNonPersonMainBusinessLineOptions,
    clientNonPersonConstitutionOptions,
    customerList,
    agentType,
  } = props;
  console.log(legalOption);
  const superAgentOptions = customerList
    ?.filter((c) => c.agentType === "SUPER_AGENT")
    .map((c) => ({ label: c?.name, value: c.id }));
  // && c?.status?.toLowerCase() === "active"

  const agentMerchantOptions = customerList
    ?.filter((c) => c.agentType === "AGENT")
    .map((c) => ({ label: c?.name, value: c.id }));

  return (
    <>
      <Form
        form={form}
        layout="vertical"
        initialValues={{ ...initialValues, initiatedBy: userData?.username }}
        disabled={true}
      >
        <Row>
          <Col span={12} style={{ padding: "0px 8px" }}>
            <Form.Item
              label={labelConfig.agentType}
              name="agentType"
              rules={[
                {
                  required: true,
                  message: BOM.CheckReqFld(labelConfig.agentType),
                },
              ]}
            >
              <Select
                className="read-only-select"
                style={{ height: "44px" }}
                placeholder="Select Agent Type"
                options={staticConfig.agentTypeData}
                suffixIcon={<ChevronDown color="#667085" width={20} />}
                showSearch
              />
            </Form.Item>
          </Col>

          {/* CONDITIONAL FIELDS START HERE */}

          {/* Case 1: If Agent or Merchant is selected, show Super Agent dropdown */}
          {(agentType === "AGENT" || agentType === "MERCHANT") && (
            <Col span={12}>
              <Form.Item
                label={labelConfig.superAgent}
                name="superAgentId"
                // rules={[
                //   { required: true, message: "Please select a Super Agent" },
                // ]}
              >
                <Select
                  style={{ height: "44px" }}
                  placeholder="Select Super Agent to attach"
                  options={superAgentOptions}
                  className="read-only-select"
                  suffixIcon={<ChevronDown color="#667085" width={20} />}
                />
              </Form.Item>
            </Col>
          )}

          {/* Case 2: If Super Agent is selected, show Multi-select for Agents/Merchants */}
          {agentType === "SUPER_AGENT" && (
            <Col span={12} style={{ padding: "0px 8px" }}>
              <Form.Item
                label="Assign Agents"
                name="listOfAgents"
                // rules={[
                //   {
                //     required: true,
                //     message: "Please assign at least one agent",
                //   },
                // ]}
              >
                <Select
                  className="read-only-select"
                  mode="multiple"
                  style={{ width: "100%", height: "44px" }}
                  placeholder="Select multiple agents"
                  options={agentMerchantOptions}
                  suffixIcon={<ChevronDown color="#667085" width={20} />}
                />
              </Form.Item>
            </Col>
          )}
          <Col span={12} style={{ padding: "0px 8px" }}>
            <Form.Item
              label={labelConfig.legalForm}
              name="legalFormId"
              rules={[
                {
                  required: true,
                  message: BOM.CheckReqFld(labelConfig.legalForm),
                },
              ]}
            >
              <Select
                className="read-only-select"
                style={{ height: "44px" }}
                placeholder={BOM.handlePlaceholderMsg(
                  `${labelConfig.legalForm}`,
                  "select",
                )}
                options={legalFormData}
                suffixIcon={<ChevronDown color="#667085" width={20} />}
              />
            </Form.Item>
          </Col>
          <Col span={12} style={{ padding: "0px 8px" }}>
            <Form.Item
              label={labelConfig.branch}
              name="officeId"
              rules={[
                {
                  required: true,
                  message: BOM.CheckReqFld(labelConfig.branch),
                },
              ]}
            >
              <Input
                className="read-only-select"
                style={{ height: "44px" }}
                placeholder={BOM.handlePlaceholderMsg(
                  `${labelConfig.branch}`,
                  "select",
                )}
                // options={officeData}
                // suffixIcon={<ChevronDown color="#667085" width={20} />}
              />
            </Form.Item>
          </Col>
          {legalOption === 2 && (
            <Col span={12} style={{ padding: "0px 8px" }}>
              <Form.Item
                label={labelConfig.businessName}
                name="fullname"
                rules={[
                  {
                    required: true,
                    message: BOM.CheckReqFld(labelConfig.businessName),
                  },
                ]}
              >
                <Input
                  className="of-bold-disable-input"
                  style={{ height: "44px" }}
                  placeholder={BOM.handlePlaceholderMsg(
                    labelConfig.businessName,
                  )}
                />
              </Form.Item>
            </Col>
          )}
          {!(legalOption === 2) && (
            <>
              <Col span={12} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.firstName}
                  name="firstname"
                  rules={BOM.fieldRules("firstName", true)}
                >
                  <Input
                    className="of-bold-disable-input"
                    style={{ height: "44px" }}
                    placeholder={BOM.handlePlaceholderMsg(
                      labelConfig.firstName,
                    )}
                  />
                </Form.Item>
              </Col>
              <Col span={12} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.middleName}
                  name="middlename"
                  rules={BOM.fieldRules("middleName", false)}
                >
                  <Input
                    className="of-bold-disable-input"
                    style={{ height: "44px" }}
                    placeholder={BOM.handlePlaceholderMsg(
                      labelConfig.middleName,
                    )}
                  />
                </Form.Item>
              </Col>
              <Col span={12} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.lastName}
                  name="lastname"
                  rules={BOM.fieldRules("lastName", true)}
                >
                  <Input
                    className="of-bold-disable-input"
                    style={{ height: "44px" }}
                    placeholder={BOM.handlePlaceholderMsg(labelConfig.lastName)}
                  />
                </Form.Item>
              </Col>
              <Col span={12} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.dateOfBirth}
                  name="dateOfBirth"
                  rules={[
                    {
                      validator: (_, value) => {
                        const result = BOM.validateMinimumAge(value, 18);
                        if (!result.valid) {
                          return Promise.reject(new Error(result.message));
                        }
                        return Promise.resolve();
                      },
                    },
                  ]}
                >
                  <DatePicker
                    suffixIcon={<CalendarIcon color="#667085" width={20} />}
                    className="bond-date-picker custom-input of-bold-disable-input"
                    // defaultValue={defaultValue}
                    disabledDate={disabledAfterCurrentDate}
                    placeholder={BOM.handlePlaceholderMsg(
                      labelConfig.dateOfBirth,
                      "select",
                    )}
                    style={{ width: "100%", height: "44px" }}
                  />
                </Form.Item>
              </Col>
              <Col span={12} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.gender}
                  name="genderId"
                  rules={[
                    {
                      required: true,
                      message: BOM.CheckReqFld(labelConfig.gender),
                    },
                  ]}
                >
                  <Select
                    className="read-only-select"
                    style={{ height: "44px" }}
                    placeholder={BOM.handlePlaceholderMsg(
                      labelConfig.gender,
                      "select",
                    )}
                    options={genderData}
                    suffixIcon={<ChevronDown color="#667085" width={20} />}
                  />
                </Form.Item>
              </Col>
            </>
          )}
          {BOM.HasPermission("ACTIVATE_CLIENT") && (
            <Col span={12} style={{ padding: "0px 8px" }}>
              <Form.Item label={labelConfig.status} name="active">
                <Select
                  className="read-only-select"
                  style={{ height: "44px" }}
                  placeholder={BOM.handlePlaceholderMsg(
                    `${labelConfig.status}`,
                    "select",
                  )}
                  options={staticConfig.statusData}
                  suffixIcon={<ChevronDown color="#667085" width={20} />}
                />
              </Form.Item>
            </Col>
          )}
          {isActive && (
            <Col span={12} style={{ padding: "0px 8px" }}>
              <Form.Item
                label={labelConfig.activationDate}
                name="activationDate"
                rules={[
                  {
                    required: true,
                    message: BOM.CheckReqFld(labelConfig.activationDate),
                  },
                ]}
              >
                <DatePicker
                  suffixIcon={<CalendarIcon color="#667085" width={20} />}
                  className="bond-date-picker custom-input of-bold-disable-input"
                  disabledDate={disabledAfterCurrentDate}
                  placeholder={BOM.handlePlaceholderMsg(
                    labelConfig.activationDate,
                    "select",
                  )}
                  style={{ width: "100%", height: "44px" }}
                />
              </Form.Item>
            </Col>
          )}
          {legalOption === 2 && (
            <>
              <Col span={12} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.incorporationDate}
                  name="dateOfBirth"
                  // rules={[
                  //   {
                  //     required: idType === 2 ? false : true,
                  //     message: BOM.CheckReqFld(labelConfig.incorporationDate),
                  //   },
                  // ]}
                >
                  <DatePicker
                    suffixIcon={<CalendarIcon color="#667085" width={20} />}
                    className="bond-date-picker custom-input of-bold-disable-input"
                    disabledDate={disabledAfterCurrentDate}
                    placeholder={BOM.handlePlaceholderMsg(
                      labelConfig.incorporationDate,
                      "select",
                    )}
                    style={{ width: "100%", height: "44px" }}
                  />
                </Form.Item>
              </Col>
              <Col span={12} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.incorporationValidUntil}
                  name="incorpValidityTillDate"
                  // rules={[
                  //   {
                  //     required: idType === 2 ? false : true,
                  //     message: BOM.CheckReqFld(
                  //       labelConfig.incorporationValidUntil
                  //     ),
                  //   },
                  // ]}
                >
                  <DatePicker
                    suffixIcon={<CalendarIcon color="#667085" width={20} />}
                    className="bond-date-picker custom-input of-bold-disable-input"
                    disabledDate={disableDaysBeforeToday}
                    placeholder={BOM.handlePlaceholderMsg(
                      labelConfig.incorporationValidDate,
                      "select",
                    )}
                    style={{ width: "100%", height: "44px" }}
                  />
                </Form.Item>
              </Col>
              <Col span={12} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.constitution}
                  name="constitutionId"
                  rules={[
                    {
                      required: true,
                      message: BOM.CheckReqFld(labelConfig.constitution),
                    },
                  ]}
                >
                  <Select
                    className="read-only-select"
                    placeholder={BOM.handlePlaceholderMsg(
                      labelConfig.constitution,
                      "select",
                    )}
                    options={clientNonPersonConstitutionOptions}
                    style={{ width: "100%", height: "44px" }}
                    suffixIcon={<ChevronDown color="#667085" width={20} />}
                  />
                </Form.Item>
              </Col>
              <Col span={12} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.mainBusinessLine}
                  name="mainBusinessLineId"
                  // rules={[
                  //   {
                  //     required: true,
                  //     message: BOM.CheckReqFld(labelConfig.mainBusinessLine),
                  //   },
                  // ]}
                >
                  <Select
                    className="read-only-select"
                    placeholder={BOM.handlePlaceholderMsg(
                      labelConfig.mainBusinessLine,
                      "select",
                    )}
                    options={clientNonPersonMainBusinessLineOptions}
                    style={{ width: "100%", height: "44px" }}
                    suffixIcon={<ChevronDown color="#667085" width={20} />}
                  />
                </Form.Item>
              </Col>
            </>
          )}
          <Col span={12} style={{ padding: "0px 8px" }}>
            <Form.Item
              label={
                legalOption === 2
                  ? labelConfig.businessRegistrationNumber
                  : labelConfig.externalID
              }
              name={
                legalOption === 2 ? "businessRegistrationNumber" : "externalId"
              }
              // name="externalId"
              rules={[
                {
                  required: legalOption === 2 ? true : false,
                  validator(_, value) {
                    if (legalOption === 2 && !value) {
                      return Promise.reject(
                        new Error("Business Registration Number is required"),
                      );
                    }
                    return Promise.resolve();
                  },
                },
              ]}
            >
              <Input
                className="of-bold-disable-input"
                style={{ height: "44px" }}
                placeholder={BOM.handlePlaceholderMsg(
                  legalOption === 2
                    ? labelConfig.businessRegistrationNumber
                    : labelConfig.externalID,
                )}
              />
            </Form.Item>
          </Col>
          <Col span={12} style={{ padding: "0px 8px" }}>
            <Form.Item
              label={labelConfig.tradingName}
              name="tradingName"
              rules={[
                {
                  required: true,
                  message: BOM.CheckReqFld(labelConfig.tradingName),
                },
              ]}
            >
              <Input
                className="of-bold-disable-input"
                style={{ height: "44px" }}
                placeholder={BOM.handlePlaceholderMsg(labelConfig.tradingName)}
              />
            </Form.Item>
          </Col>
          <Col span={12} style={{ padding: "0px 8px" }}>
            <Form.Item
              label={labelConfig.taxIDNumber}
              name="taxIdentificationNumber"
              // name="incorpNumber"
              rules={[
                {
                  required: true,
                  message: BOM.CheckReqFld(labelConfig.taxIDNumber),
                },
              ]}
            >
              <Input
                className="of-bold-disable-input"
                style={{ height: "44px" }}
                placeholder={BOM.handlePlaceholderMsg(labelConfig.taxIDNumber)}
                // style={styles.ofInputFieldNumber}
              />
            </Form.Item>
          </Col>
          <Col span={12} style={{ padding: "0px 8px" }}>
            <Form.Item
              label={labelConfig.businessDecription}
              name="businessDescription"
              rules={[
                {
                  required: true,
                  message: BOM.CheckReqFld(labelConfig.businessDecription),
                },
              ]}
            >
              <Input
                className="of-bold-disable-input"
                style={{ height: "44px" }}
                placeholder={BOM.handlePlaceholderMsg(
                  labelConfig.businessDecription,
                )}
              />
            </Form.Item>
          </Col>
          <Col span={12} style={{ padding: "0px 8px" }}>
            <Form.Item
              label={labelConfig.natureOfBusiness}
              name="natureOfBusiness"
              rules={[
                {
                  required: true,
                  message: BOM.CheckReqFld(labelConfig.natureOfBusiness),
                },
              ]}
            >
              <Input
                className="of-bold-disable-input"
                style={{ height: "44px" }}
                placeholder={BOM.handlePlaceholderMsg(
                  labelConfig.natureOfBusiness,
                )}
              />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </>
  );
};

export default General;
